import {Component} from '@angular/core';

@Component({
  selector: 'app-start-page',
  template: `<h1>Welcome to the Beltsville Agricultural Research Center Information Repository</h1>

  <p>
    The U.S. Department of Agriculture's <a href="http://www.ars.usda.gov" target="_blank">Agricultural Research Service</a>
    (ARS) is conducting Comprehensive Environmental Response, Compensation, and Liability Act (CERCLA or "Superfund") activities at the
    <a href="http://www.ars.usda.gov/main/site_main.htm?modecode=12-00-00-00" target="_blank">Beltsville Agricultural Research Center</a>
    (BARC). As part of this effort, ARS is committed to keeping the local community and all other
    interested parties informed about CERCLA activities at BARC.
  </p>

  <p>
    BARC was placed on National Priorities List (NPL) in 1994 and has been addressing contamination issues throughout the BARC campus since that time.
  Many of the sites have already been cleaned up or are involved in investigations aimed at completing cleanups. Since being placed on Superfund, BARC
  has made the reports and records related to environmental investigation and cleanup activities accessible to the public.
  </p>

  <p>
    This website has expanded the accessibility of this information. Now, interested individuals may view all current Superfund information via the Internet.
    These documents have been, and continue to be, available in paper format, and are viewable at the BARC Information Repository in Building 003 at BARC.
  </p>

  <h2>How Do I View This Information?</h2>

  <p>
    A total of 63 "Areas of Concern" (AOCs) have been identified as AOCs at BARC that are being investigated and cleaned up as part of ARS'
    Superfund initiatives, 21 of which are still being actively investigated. The information related to all of these sites, regardless of status,
    are available through this Web site through one of two means:
  </p>

  <h3>Map Search</h3>

  <p>
    Documents may be displayed by site location within the BARC campus. To view the documents for a specific site, click on the
    "<a routerLink="/mapsearch">Map Search</a>" link. Then, click on the map within to pull up a larger map of BARC and the AOCs that are
    being investigated. Simply click on the site of interest to display all of the documents associated with a particular site.
  </p>

  <h3>Advanced Search</h3>
  <p>
    Documents also may be searched using other identifiers, such as farm name, document title, and document date.
    To search for documents in this manner, click on the "<a routerLink="/advancedsearch">Advanced Search</a>" link, fill out
    the appropriate form fields, and "Search".
  </p>

  <h2>Important Facility-Wide Information</h2>

  <h3>BARC Facility General Information</h3>
  <p>
    To view general information about the entire BARC facility, click on the “<a [routerLink]="['advancedsearch']">Advanced Search</a>"
    link and select the "BARC-Wide" option under the "Site Name" criteria.
  </p>
  <ul class="home-doc-links">
    <li><a target="_blank" href="/documents/BARC AOC Full Map 2019.pdf">BARC’s Areas of Concern (AOC) Full Map</a></li>
    <li><a target="_blank" href="/documents/2018-2019 Site Management Plan - October v1.pdf">BARC’s Current Site Management Plan</a></li>
    <li><a target="_blank" href="/documents/2006 BERA.pdf">BARC’s Baseline Ecological Risk Assessment</a>
    <li><a target="_blank" href="https://www.ars.usda.gov/northeast-area/docs/cerclasuperfund/">BARC’s CERCLA Fact Sheets and Maps</a></li>
  </ul>
  <h3>BARC Master Plans</h3>
  <p>
    Four BARC Master Plans guide the implementation of all CERCLA-related studies and remedial activities, data collection, and risk management
    efforts to ensure that work consistently follows procedures, provides for safe working conditions, and that regulations are adhered to.
    These four master plans include (1) Master Health and Safety Plan (HASP), (2) Master Quality Assurance Project Plan (QAPP), (3) Master
    Investigation Derived Waste (IDW) Management Plan, and (4) Master Risk Assessment Plan (RAP). The most current version of each plan is
    provided below and they are updated periodically.
  </p>
  <ul class="home-doc-links">
    <li><a target="_blank" href="/documents/F-01-0149_Master Health and Safety Plan - Beltsville Agricultural Research Center - 2020.pdf">Master Health and Safety Plan</a></li>
    <li><a target="_blank" href="/documents/F-01-0150_Master Quality Assurance Project Plan - Beltsville Agricultural Research Center - 2007.pdf">Master Quality Assurance Project Plan</a></li>
    <li><a target="_blank" href="/documents/BARC Master IDW Plan 2020 Update_FINAL_Complete.pdf">Master Investigation Derived Waste Management Plan</a></li>
    <li><a target="_blank" href="/documents/F-11-0230_BARC Master Risk Assessment Plan - 2020.pdf">Master Risk Assessment Plan</a></li>
  </ul>
  `
})
export class BarcLandingPageComponent { }



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/irar/containers/barc-landing.ts